import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { GetChannelMessageStatus } from "../schemas/schemas_0";
export { $Command };
export class GetChannelMessageStatusCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "GetChannelMessageStatus", {})
    .n("ChimeSDKMessagingClient", "GetChannelMessageStatusCommand")
    .sc(GetChannelMessageStatus)
    .build() {
}
